























































import Vue, { PropType } from 'vue';

import { ProfileInfo } from 'spa_registration_app/store/modules/register';
import ProfileImagePreview from '../../components/profile-image-preview.vue';
import CvPreview from '../../components/cv-preview.vue';
import AvatarInput from '@/components/AvatarInput.vue';

export default Vue.extend({
  components: {
    AvatarInput,
    ProfileImagePreview,
    CvPreview,
  },
  props: {
    profileInfo: {
      type: Object as PropType<ProfileInfo>,
      required: true,
    },
    pErrors: {
      type: Array as PropType<string[]>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    const { profile_image } = this.profileInfo;
    return {
      formData: {
        profile_image,
        remove_profile_image: false,
      },
    };
  },
  methods: {
    onSubmit() {
      this.$emit('submit');
    },
    onChangeProfileImage({
      profile_image,
      remove_profile_image,
    }: {
      profile_image: File;
      remove_profile_image: boolean;
    }) {
      this.formData.profile_image = profile_image;
      this.formData.remove_profile_image = remove_profile_image;
      this.$emit('change', profile_image);
    },
  },
});
